module.exports = __webpack_public_path__ + "static/media/music.d5b52b44.png";